<template>
  <el-card shadow="never">
    <div class="cust-card d-flex flex-row align-items-center">
      <div class="d-flex flex-row flex-grow-1">
        <div class="d-flex">
          <el-avatar shape="square" :src="userInfo.avatar || defaultAvatar" />
        </div>
        <div class="px-2 flex-grow-1 d-flex flex-column">
          <div class="flex-grow-1 d-flex align-items-center">
            <div class="user-name">{{ displayUserName }}</div>
          </div>
          <div class="user-other-info">
            <div v-if="userInfo.userJobType">
              <i class="fa fa-user-circle-o" />
              {{ userInfo.userJobType }}
            </div>
            <div v-if="displayOrgDept">
              <i class="fa fa-sitemap" />
              {{ displayOrgDept }}
            </div>
            <div v-if="userInfo.email">
              <i class="fa fa-envelope" />
              {{ userInfo.email }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <el-button
          v-if="allow('A')"
          type="primary"
          size="small"
          @click="$emit('create-cust')"
        >
          {{ $l('btn_create') || '新增客户' }}
        </el-button>
      </div>
    </div>
    <div>
      <slot />
    </div>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import { format } from '@/libs/util.number.js'
export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      userPerformance: {},
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    displayUserName() {
      const { userName, userNameEn } = this.userInfo
      return [userName, userNameEn].filter(Boolean).join(' ')
    },
    displayOrgDept() {
      const { org, dept } = this.userInfo
      return [org, dept].filter(Boolean).join('/')
    },
    orderAmount() {
      const orderAmount = this.userPerformance?.orderAmount || 0
      if (!orderAmount) return '$0'
      return `$${format(orderAmount)}`
    },
    projectNumber() {
      const projectNumber = this.userPerformance?.projectNumber || 0
      if (!projectNumber) return 0
      return format(projectNumber)
    },
    sampleNumber() {
      const sampleNumber = this.userPerformance?.sampleNumber || 0
      if (!sampleNumber) return 0
      return format(sampleNumber)
    },
    budgetProgress() {
      return this.userPerformance?.budgetProgress || 0
    },
  },
  mounted() {
    this.getUserPerformance()
  },
  methods: {
    async getUserPerformance() {
      const res = await this.$api
        .masterCustomerUserPerformanceApi()
        .catch(() => null)
      if (!res) return
      this.userPerformance = res.body
    },
  },
}
</script>

<style lang="scss" scoped>
.cust-card {
  display: flex;
  .user-name {
    font-size: 16px;
    color: #101010;
  }
  .user-other-info {
    color: #8e8e8e;
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    div {
      margin-top: 8px;
      margin-right: 20px;
    }
  }
}

::v-deep {
  .cust-card .el-avatar {
    --size: 60px;
    width: var(--size);
    height: var(--size);
  }
  .el-card__body {
    padding-bottom: 0;
  }
}
</style>
